export default "__VITE_ASSET__e5ba33e7__"